import { motion } from 'framer-motion';
import Balancer from 'react-wrap-balancer';

import { fadeUp, revealOnView, stagger } from '@marketing/motion/variants';

// ============================================================
// DualIdentityBlock — Lume (público) ↔ TEACare (programa)
// ============================================================

const rows = [
  ['Domínio', 'lume.med.br · app.lume.med.br', 'teacare.org.br (programa)'],
  ['Marca', 'User-facing (paciente, cuidador, médico)', 'Regulatória (CEP-CONEP, ANPD, CFM)'],
  ['Manifestações', 'Manifest PWA, telas, comunicações', 'Publicações, RIPD, TCLE/TALE'],
  ['Identidade dupla', 'Lume', 'TEACare'],
];

export function DualIdentityBlock() {
  return (
    <section
      className="lume-section lume-section--alt"
      aria-labelledby="identity-title"
    >
      <div className="lume-container">
        <motion.div
          {...revealOnView}
          variants={stagger(0.1)}
          className="lume-grid-2"
          style={{ alignItems: 'center', gap: 'clamp(2rem, 4vw, 4rem)' }}
        >
          <motion.div variants={fadeUp} className="lume-stack lume-stack-md">
            <p className="lume-eyebrow">Identidade dupla</p>
            <h2 id="identity-title" className="lume-h2 lume-text-balance">
              <Balancer>O Programa TEACare desenvolveu o aplicativo Lume.</Balancer>
            </h2>
            <p className="lume-body-lg lume-text-pretty">
              Esta é a fórmula canônica do programa. <strong>Lume</strong> é a marca pública usada em
              tudo que o paciente, cuidador e médico veem. <strong>TEACare</strong> é o nome técnico
              do programa de pesquisa, usado em publicações científicas, conformidade regulatória e
              auditoria. Mantemos a separação rigorosamente para preservar clareza institucional.
            </p>
          </motion.div>

          <motion.div variants={fadeUp}>
            <div
              role="table"
              aria-label="Comparação Lume vs TEACare"
              style={{
                background: 'var(--color-bg-surface)',
                border: '1px solid var(--color-border-default)',
                borderRadius: '1rem',
                overflow: 'hidden',
                boxShadow: 'var(--shadow-elev1)',
              }}
            >
              <div
                role="rowgroup"
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1.5fr 1.5fr',
                  background: 'var(--color-bg-muted)',
                  fontFamily: 'var(--font-display)',
                  fontSize: '0.78rem',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                  color: 'var(--color-fg-subtle)',
                  padding: '0.85rem 1rem',
                  borderBottom: '1px solid var(--color-border-default)',
                }}
              >
                <span role="columnheader">Aspecto</span>
                <span role="columnheader" style={{ color: 'var(--color-brand-900)' }}>
                  Lume
                </span>
                <span role="columnheader">TEACare</span>
              </div>
              {rows.map(([k, lume, teacare], i) => (
                <div
                  key={k}
                  role="row"
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1.5fr 1.5fr',
                    padding: '0.9rem 1rem',
                    fontSize: '0.875rem',
                    borderTop:
                      i === 0 ? 'none' : '1px solid var(--color-border-subtle)',
                    color: 'var(--color-fg-default)',
                  }}
                >
                  <span role="cell" style={{ color: 'var(--color-fg-subtle)' }}>{k}</span>
                  <span role="cell" style={{ fontWeight: 500 }}>{lume}</span>
                  <span role="cell" style={{ color: 'var(--color-fg-muted)' }}>{teacare}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
